/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AcceptInviteRequest
 */
export interface AcceptInviteRequest {
    /**
     * 
     */
    token: string;
    /**
     * 
     */
    password?: string | null;
}

/**
 * Check if a given object implements the AcceptInviteRequest interface.
 */
export function instanceOfAcceptInviteRequest(value: object): value is AcceptInviteRequest {
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function AcceptInviteRequestFromJSON(json: any): AcceptInviteRequest {
    return AcceptInviteRequestFromJSONTyped(json, false);
}

export function AcceptInviteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcceptInviteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
        'password': json['password'] === undefined ? undefined : json['password'] === null ? null : json['password'],
    };
}

export function AcceptInviteRequestToJSON(json: any): AcceptInviteRequest {
    return AcceptInviteRequestToJSONTyped(json, false);
}

export function AcceptInviteRequestToJSONTyped(value?: AcceptInviteRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
        'password': value['password'],
    };
}

